export enum PlayerStatus {
  None,
  Ready,
  PlayRequest,
  Playing,
  StopRequest,
  Stopped,
  Warning,
  Error,
  Buffering
}

export interface IMediaStream {
  type: 'hls';
  source: string;
  label: string;
}
